import { Grid, TextField } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../app-context';
import IForm from '../../components/i-form/i-form.component';
import ITextField from '../../components/text-component/textfield/i-textfield.component';
import { isNotNull } from '../common/util.services';
import { getGeneralTaskById, saveGeneralTask } from './task.services';
import IDropdown from '../../components/text-component/dropdown/i-dropdown.component';
import { GET_GEN_TASK_URL } from '../common/constants';
import IDateField from '../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';

const GeneralTaskForm = (props: any) => {
  const [title, setTitle] = useState<string>('Add Task');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rowId = params.rowId;
  const [taskData, setTaskData] = useState<any>({targetDate: dayjs(), status: 'Pending', completionDate: dayjs()});
  const [status, setStatus] = useState('Pending');
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (isNotNull(rowId)) {
      getGeneralTaskById(rowId, appContext,
        (response: any) => {
          setTitle('Edit Task');
          response.data.targetDate = dayjs(response.data.targetDate);
          response.data.completionDate = null === response.data.completionDate ? dayjs() : dayjs(response.data.completionDate);
          setStatus(response.data.status);
          setTaskData(response.data);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, []);

  const onSubmit = (data: any) => {
    saveGeneralTask(data, appContext,
      (response: any) => {
        navigate('/task/general/list');
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={2}>
        <IDropdown name='taskOwner' label='Task Owner' required={true} url={GET_GEN_TASK_URL} />
      </Grid>
      <Grid xs={2}>
        <IDropdown name='priority' label='Priority' required={true} itemList={['Low', 'Medium', 'High']} />
      </Grid>
      <Grid xs={3}>
        <IDateField name='targetDate' label='Target Date' required={true} />
      </Grid>
      <Grid xs={2}>
        <IDropdown name='status' label='Status' required={true} itemList={['Pending', 'Completed']}
          onChangeEvent={(e: any) => { setStatus(e.target.value)}}/>
      </Grid>
      <Grid xs={3}>
        <IDateField name='completionDate' label='Completion Date' required={true} disabled={'Completed' !== status}/>
      </Grid>
      <Grid xs={9}>
        <ITextField name='task' label='Task' required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='remarks' label='Remarks' />
      </Grid>
      <Grid xs={12}>
        <TextField name='comments' label={'Comments'} multiline={true} fullWidth={true} type='string'
                   margin='dense' inputProps={{ style: { height: "20px"}}} required={true} value={taskData.comments}
                   variant="outlined" rows={5} disabled={true}/>
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={taskData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default GeneralTaskForm;